import { Table, Text, Group } from '@mantine/core';
import { ChevronDown, ChevronRight } from 'lucide-react';
import classes from '../../common/ConfigurableTable/ConfigurableTable.module.css';

interface CollapsibleGroupHeaderProps {
  label: string;
  count: number;
  colSpan: number;
  isCollapsed: boolean;
  onToggle: () => void;
  /** Optional label after the count, e.g. "sessions" → "(5 sessions)" */
  entityLabel?: string;
  /** MDF-39: nesting level, 0 = outermost. Inner levels are indented and do not stick. */
  depth?: number;
}

export function CollapsibleGroupHeader({
  label,
  count,
  colSpan,
  isCollapsed,
  onToggle,
  entityLabel,
  depth = 0,
}: CollapsibleGroupHeaderProps) {
  return (
    <Table.Tr>
      <Table.Td
        colSpan={colSpan}
        className={depth === 0 ? classes.stickyGroupHeader : undefined}
        style={{
          backgroundColor: depth === 0 ? '#f0eeea' : '#f7f6f3',
          fontWeight: 600,
          fontSize: 12,
          textTransform: 'uppercase',
          letterSpacing: 0.3,
          padding: `6px 16px 6px ${16 + depth * 24}px`,
          cursor: 'pointer',
        }}
        onClick={onToggle}
      >
        <div
          className={classes.stickyGroupHeaderContent}
          role="button"
          tabIndex={0}
          aria-expanded={!isCollapsed}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onToggle();
            }
          }}
        >
          <Group gap={6}>
            {isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />}
            <Text size="xs" fw={700} tt="uppercase" style={{ letterSpacing: 0.3 }}>
              {label}
            </Text>
            <Text size="xs" c="dimmed">
              ({count}{entityLabel ? ` ${entityLabel}` : ''})
            </Text>
          </Group>
        </div>
      </Table.Td>
    </Table.Tr>
  );
}
